export const foreignKeyMapping = {
  contacts: "contact_id",
  companies: "company_id",
  deals: "deal_id",
  loads: "load_id",
  leads: "lead_id",
};
